<template>
  <div class="gi">
    <div class="gi-title">Get immediate insights on<br />485x eligibility and UAP zoning bonus</div>
    <div class="gi-subtitle">Enter your details:</div>
    <div class="gi-images">
      <img src="@/assets/stroke.png" alt="Get Insights 1" width="160" height="78"/>
      <img src="@/assets/stroke-arrow.png" alt="Get Insights 2" width="225" />
    </div>
    <SearchComponent :order="'page top search'"></SearchComponent>
  </div>
</template>

<script>
import SearchComponent from '@/components/SearchComponent.vue';

export default {
  name: 'GetInsights',
  components: {
    SearchComponent,
  },
}
</script>

<style scoped>
.gi {
  display: flex;
  width: 100%;
  padding: 80px 4px 120px 4px;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  background: #FFF;

  position: relative;
}

.gi-title {

  color: var(--Font-navy, #0A1250);
  text-align: center;

  /* H1 */
  font-family: "Open Sans";
  font-size: 48px;
  font-style: normal;
  font-weight: 600;
  line-height: 125%;
  /* 60px */
}

.gi-subtitle {
  color: var(--Font-navy, #0A1250);
  text-align: center;
  font-family: "Open Sans";
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  /* 48px */
  margin-top: 10px;
  /* margin-bottom: 8px; */
}

.gi-images {
  position: absolute;
  top: 280px;
  display: flex;
  width: 900px;
  justify-content: space-between;

  img:nth-child(1) {
    transform: rotate(12deg);
    margin-top: -50px;
  }

  img:nth-child(2) {
    margin-right: -50px;
    margin-top: -20px;
  }
}
</style>
